import twentyFourSeven from '~/assets/icons/247.svg';
import bank from '~/assets/icons/bank.svg';
import barber from '~/assets/icons/barber.svg';
import buyers from '~/assets/icons/buyers.svg';
import car from '~/assets/icons/car.svg';
import chipCar from '~/assets/icons/chip_car.svg';
import fishing from '~/assets/icons/fishing.svg';
import gaz from '~/assets/icons/gaz.svg';
import globe from '~/assets/icons/globe.svg';
import hospital from '~/assets/icons/hospital.svg';
import job from '~/assets/icons/job_2.svg';
import paint from '~/assets/icons/paint.svg';
import tattoo from '~/assets/icons/tattoo.svg';
import tshirt from '~/assets/icons/tshirt.svg';
import turbo from '~/assets/icons/turbo.svg';
import { MapPointCategory } from '~/shared';

export enum GPSCategory {
	Important = 'important',
	Work = 'work',
	Bank = 'bank',
	TwentyFourSeven = '24/7',
	Clothing = 'clothing',
	Hobby = 'hobby',
	Hospital = 'hospital',
	TattooParlor = 'tattoo_parlor',
	Barbershop = 'barbershop',
	Tuning = 'tuning',
	CarDealerships = 'car_dealerships',
	GasStations = 'gas_stations',
	Buyers = 'buyers',
	Painting = 'painting',
	VehicleTuning = 'vehicle_tuning',
}

export const GPSCategoryLabels: Record<MapPointCategory, string> = {
	[MapPointCategory.IMPORTANT]: 'Важное',
	[MapPointCategory.WORK]: 'Работа',
	[MapPointCategory.BANK]: 'Банк',
	[MapPointCategory.SHOP]: '24/7',
	[MapPointCategory.CLOTHES_SHOP]: 'Одежда',
	[MapPointCategory.HOBBY]: 'Хобби',
	[MapPointCategory.HOSPITAL]: 'Больница',
	[MapPointCategory.TATTOO_SALON]: 'Тату салон',
	[MapPointCategory.HAIR_SALON]: 'Прически',
	[MapPointCategory.TUNING_STATION]: 'Тюнинг',
	[MapPointCategory.CAR_SHOWROOM]: 'Автосалоны',
	[MapPointCategory.GAS_STATION]: 'Заправки',
	[MapPointCategory.BUYERS]: 'Скупщики',
	[MapPointCategory.PAINTING]: 'Покраска',
	[MapPointCategory.VEHICLE_TUNING]: 'Настройка ТС',
};

// @TODO: добавить остальные иконки
export const GPSCategoryIcons: Record<MapPointCategory, string> = {
	[MapPointCategory.IMPORTANT]: globe,
	[MapPointCategory.WORK]: job,
	[MapPointCategory.BANK]: bank,
	[MapPointCategory.SHOP]: twentyFourSeven,
	[MapPointCategory.CLOTHES_SHOP]: tshirt,
	[MapPointCategory.HOBBY]: fishing,
	[MapPointCategory.HOSPITAL]: hospital,
	[MapPointCategory.TATTOO_SALON]: tattoo,
	[MapPointCategory.HAIR_SALON]: barber,
	[MapPointCategory.TUNING_STATION]: turbo,
	[MapPointCategory.CAR_SHOWROOM]: car,
	[MapPointCategory.GAS_STATION]: gaz,
	[MapPointCategory.BUYERS]: buyers,
	[MapPointCategory.PAINTING]: paint,
	[MapPointCategory.VEHICLE_TUNING]: chipCar,
};

export const GPSCategoryTitles: Record<MapPointCategory, string> = {
	[MapPointCategory.IMPORTANT]: 'Важные места',
	[MapPointCategory.WORK]: 'Места работы',
	[MapPointCategory.BANK]: 'Ближайшие банки',
	[MapPointCategory.SHOP]: 'Ближайшие магазины 24/7',
	[MapPointCategory.CLOTHES_SHOP]: 'Ближайшие магазины одежды',
	[MapPointCategory.HOBBY]: 'Места для хобби',
	[MapPointCategory.HOSPITAL]: 'Ближайшие больницы',
	[MapPointCategory.TATTOO_SALON]: 'Ближайшие тату салоны',
	[MapPointCategory.HAIR_SALON]: 'Ближайшие парикмахерские',
	[MapPointCategory.TUNING_STATION]: 'Ближайшие тюнинг ателье',
	[MapPointCategory.CAR_SHOWROOM]: 'Ближайшие автосалоны',
	[MapPointCategory.GAS_STATION]: 'Ближайшие заправки',
	[MapPointCategory.BUYERS]: 'Ближайшие скупщики',
	[MapPointCategory.PAINTING]: 'Ближайшие покраска авто',
	[MapPointCategory.VEHICLE_TUNING]: 'Ближайшие настройка ТС',
};
